import { render, staticRenderFns } from "./StackedColumns.vue?vue&type=template&id=ae0d3100&"
import script from "./StackedColumns.vue?vue&type=script&lang=js&"
export * from "./StackedColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports